import React, { useState } from 'react';
import { CheckSquare } from 'lucide-react';
import { useTask } from '../../contexts/TaskContext';
import TaskMenu from './TaskMenu';
import TaskAssignmentModal from './TaskAssignmentModal';

const TaskIcon = () => {
  const { assignedToMe } = useTask();
  const [menuOpen, setMenuOpen] = useState(false);
  const [assignmentModalOpen, setAssignmentModalOpen] = useState(false);

  // Okunmamış görev sayısı (pending ve in_progress)
  const unreadCount = assignedToMe.filter(
    task => task.status === 'pending' || task.status === 'in_progress'
  ).length;

  return (
    <>
      <div className="relative">
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className={`relative p-2 rounded-lg transition-colors ${
            unreadCount > 0
              ? 'text-blue-600 dark:text-blue-400 bg-blue-50 dark:bg-blue-900/20'
              : 'text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700'
          }`}
        >
          <CheckSquare className="w-5 h-5" />
          {unreadCount > 0 && (
            <>
              <span className="absolute top-0 right-0 w-5 h-5 bg-red-500 rounded-full flex items-center justify-center text-[10px] font-bold text-white animate-pulse">
                {unreadCount > 9 ? '9+' : unreadCount}
              </span>
              {/* Pulse animasyonu için ek overlay */}
              <span className="absolute top-0 right-0 w-5 h-5 bg-red-500 rounded-full animate-ping opacity-75" />
            </>
          )}
        </button>
        {menuOpen && (
          <TaskMenu
            onClose={() => setMenuOpen(false)}
            onNewTask={() => {
              setMenuOpen(false);
              setAssignmentModalOpen(true);
            }}
          />
        )}
      </div>
      {assignmentModalOpen && (
        <TaskAssignmentModal
          onClose={() => setAssignmentModalOpen(false)}
          onSuccess={() => {
            setAssignmentModalOpen(false);
          }}
        />
      )}
    </>
  );
};

export default TaskIcon;

